/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 * Confirm Button - Save design and redirect to Haravan
 * Updated: 2026-01-09
 */

import React from 'react';
import { Loader } from 'lucide-react';

interface ConfirmButtonProps {
  onClick: () => Promise<void>;
  disabled: boolean;
  loading: boolean;
}

const ConfirmButton: React.FC<ConfirmButtonProps> = ({ onClick, disabled, loading }) => {
  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled || loading) {
      e.preventDefault();
      return;
    }
    try {
      await onClick();
    } catch (err) {
      console.error('Error in confirm button:', err);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled || loading}
      className={`w-full py-2.5 lg:py-3 px-4 lg:px-6 rounded-xl font-bold text-sm lg:text-base text-white transition-all flex items-center justify-center gap-2 shadow-lg ${
        disabled || loading
          ? 'bg-gray-300 cursor-not-allowed shadow-none'
          : 'bg-[rgb(6,182,212)] hover:bg-[rgb(4,160,185)] active:scale-[0.98] shadow-[rgb(6,182,212)]/30'
      }`}
    >
      {loading ? (
        <>
          <Loader className="w-4 h-4 lg:w-5 lg:h-5 animate-spin" />
          <span>ĐANG XỬ LÝ...</span>
        </>
      ) : (
        <span>XÁC NHẬN THIẾT KẾ</span>
      )}
    </button>
  );
};

export default ConfirmButton;
